import * as React from 'react';
import { Box, Stack, useMediaQuery, Dialog, DialogContent } from '@mui/material';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import SpinnerCheck from '../../icons/SpinnerCheck.png';

//FacebookCircularProgress props type
interface FCPPropsType {
  status?: string | null;
  closeCancelModal?: () => void;
  close?: () => void;
  fastSpinner?: boolean;
}

function FacebookCircularProgress(props: FCPPropsType) {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    let timer2: any = null;
    let timer1: any = null;

    timer1 = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + (props.fastSpinner ? 20 : 5)));
    }, 100);
    if (props?.status && progress === 100) {
      clearInterval(timer1);
      timer2 = setInterval(() => {
        props.closeCancelModal && props.closeCancelModal();
        props.close && props.close();
      }, 1000);
    }

    return () => {
      clearInterval(timer1);
      clearInterval(timer2);
    };
  }, [progress, props]);

  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) => theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        }}
        size={123}
        thickness={6}
        value={100}
      />
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) => (theme.palette.mode === 'light' ? '#053742' : '#053742'),
          animationDuration: '1.2s',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={123}
        thickness={6}
        value={progress}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {props?.status && progress === 100 ? <img src={SpinnerCheck} alt="" style={{ width: '60px' }} /> : <></>}
      </Box>
    </Box>
  );
}

//CustomizedProgressBars props type
interface CPBPropsType {
  openSpinnerModal: boolean;
  width?: string;
  height?: string;
  isInvisible?: boolean;
  shrink?: boolean;
  spinnerStatus?: string | null;
  handleCloseSpinnerModal?: () => void;
  closeCancel?: () => void;
  fastSpinner?: boolean; //optional prop to make the spinner complete fast
}

export default function CustomizedProgressBars(props: CPBPropsType) {
  const isOnMobileScreen = useMediaQuery('(max-width:600px)');

  return (
    <Dialog
      open={props.openSpinnerModal}
      onClose={props.handleCloseSpinnerModal}
      fullScreen={isOnMobileScreen}
      BackdropProps={{
        invisible: props.isInvisible ?? false,
      }}
      fullWidth={true}
      disableEnforceFocus
      PaperProps={{
        style: {
          pointerEvents: 'auto',
          width: props.shrink ? '220px' : props.width,
          borderRadius: isOnMobileScreen ? '0' : '24px',
          boxShadow: 'none',
          height: props.shrink ? '200px' : props.height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
    >
      <DialogContent sx={{ height: '100%' }}>
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} height={'100%'}>
          <FacebookCircularProgress status={props?.spinnerStatus} close={props.handleCloseSpinnerModal} closeCancelModal={props.closeCancel} fastSpinner={props.fastSpinner} />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
